import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PurchaseSection } from '../components/PurchaseSection';
import { UpsellSection } from '../components/UpsellSection';
import { MegapackProyectosSection } from '../components/MegapackProyectosSection';
import { MegapackSection } from '../components/MegapackSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function LandingPage() {
  return <main className="min-h-screen font-sans text-gray-900 bg-white overflow-x-hidden" data-id="element-468">
      <Hero data-id="element-469" />
      <ProblemSection data-id="element-470" />
      <SolutionSection data-id="element-471" />
      <ModulesSection data-id="element-472" />
      <BonusSection data-id="element-473" />
      <PurchaseSection data-id="element-474" />
      <UpsellSection data-id="element-475" />
      <MegapackProyectosSection data-id="element-476" />
      <MegapackSection data-id="element-477" />
      <GuaranteeSection data-id="element-478" />
      <TestimonialsSection data-id="element-479" />
      <FAQSection data-id="element-480" />
      <PurchaseNotification data-id="element-481" />

      {/* Footer */}
      <footer className="bg-blue-900 text-white py-8 px-4 text-center" data-id="element-482">
        <p className="text-lg font-medium text-blue-200 mb-2" data-id="element-483">
          Abrís el archivo. Das la clase. El año está resuelto.
        </p>
        <p className="text-blue-300/80 text-sm" data-id="element-484">
          © 2026 Teoría de las Organizaciones 360. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}